export default "__VITE_ASSET__D832mHFS__"